import { ReactNode, useEffect, useRef, useState } from 'react';

import { Box } from 'components/Box';

type Props = {
  children: ReactNode;
};

export function FixedSpacerContainer({ children }: Props) {
  const ref = useRef(null);
  const [height, setHeight] = useState('auto');
  useEffect(() => {
    const update = () => {
      // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
      if (ref && ref.current) {
        // @ts-expect-error TS(2339): Property 'offsetHeight' does not exist on type 'ne... Remove this comment to see the full error message
        setHeight(ref.current.offsetHeight || 'auto');
      }
    };

    update();

    if (window) {
      window.addEventListener('resize', update);
      return window.addEventListener('resize', update);
    }
  }, [children]);
  return (
    <Box height={height}>
      <Box
        position="fixed"
        bottom={0}
        left={0}
        zIndex={80}
        transform="translateZ(0)"
        width="100%"
      >
        <div ref={ref}>{children}</div>
      </Box>
    </Box>
  );
}
